import { APP_ROUTES } from "./routeHelpers";

/**
 * Which grant a screen needs. Two separate per-person grants, both set from
 * the admin console and both enforced again on the server:
 *
 *   mcapAccess  — the analytics screens (McapAccessGuard).
 *   inboxAccess — the WhatsApp inbox (RequireInboxAccess). Separate on purpose:
 *                 MCAP access can go to teacher accounts, and the inbox shows
 *                 every lead's phone number and messages.
 *
 * Either grant gets a person into the app; each screen then needs its own.
 * Only `true` counts: an absent or null flag (a record persisted before the
 * flag existed) denies.
 */
export const ACCESS = { MCAP: "mcap", INBOX: "inbox", ANY: "any" };

const granted = (user, access) => {
  if (access === ACCESS.INBOX) return user?.inboxAccess === true;
  if (access === ACCESS.ANY) return user?.mcapAccess === true || user?.inboxAccess === true;
  return user?.mcapAccess === true;
};

/** A route or sidebar item with no `access` is an analytics screen. */
export const canSee = (item, user) => granted(user, item?.access ?? ACCESS.MCAP);

export const hasAnyAccess = (user) => granted(user, ACCESS.ANY);

/** Where a signed-in person lands, and where unknown paths send them. */
export const homeRoute = (user) => (user?.mcapAccess === true ? APP_ROUTES.OVERVIEW : APP_ROUTES.INBOX);
